type ShouldBeComponentType = {
  home: string[];
  postal_code: string[];
  street: string[];
  region: string[];
  city: string[];
  country: string[];
};

interface formatAddressProps {
  name?: string;
  home?: string;
  formattedAddress?: string;
}
export const formatAddress = ({
  name,
  home,
  formattedAddress,
}: formatAddressProps) => {
  // Check if formattedAddress includes name
  if (name && formattedAddress?.includes(name)) {
    // If home is present in formattedAddress, return only name and formattedAddress
    return `${formattedAddress}`;
  }
  if (name && !formattedAddress?.includes(name)) {
    // If home is present in formattedAddress, return only name and formattedAddress
    return `${name}, ${formattedAddress}`;
  }

  // If home is an empty string, only include name and formattedAddress
  if (!home) {
    return `${name}, ${formattedAddress}`;
  }

  // If home is not empty and not included in formattedAddress, include all three
  return `${name}, ${home}, ${formattedAddress}`;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getAddressObject = (address_components: any) => {
  const ShouldBeComponent: ShouldBeComponentType = {
    home: ["route", "subpremise"],
    postal_code: ["postal_code", "postal_code_prefix"],
    street: ["sublocality_level_1", "neighborhood"],
    region: [
      "administrative_area_level_1",
      "administrative_area_level_2",
      "administrative_area_level_3",
      "administrative_area_level_4",
      "administrative_area_level_5",
    ],
    city: [
      "locality",
      "sublocality",
      "sublocality_level_1",
      "sublocality_level_2",
      "sublocality_level_3",
      "sublocality_level_4",
    ],
    country: ["country"],
  };

  const address = {
    home: "",
    postal_code: "",
    street: "",
    region: "",
    city: "",
    country: "",
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  address_components.forEach((component: any) => {
    for (const shouldBe in ShouldBeComponent) {
      if (
        ShouldBeComponent[shouldBe as keyof typeof ShouldBeComponent].indexOf(
          component.types[0]
        ) !== -1
      ) {
        if (shouldBe === "country" || shouldBe === "region") {
          address[shouldBe as keyof typeof address] = component.short_name;
        } else {
          address[shouldBe as keyof typeof address] = component.long_name;
        }
      }
    }
  });
  return address;
};

// address1: 'street_number,'route'
// address2: 'sublocality_level_1'
